import { render } from "./privacyZh.vue?vue&type=template&id=43cdb5f2&scoped=true"
import script from "./privacyZh.vue?vue&type=script&lang=js"
export * from "./privacyZh.vue?vue&type=script&lang=js"

import "./privacyZh.vue?vue&type=style&index=0&id=43cdb5f2&scoped=true&lang=scss"

import exportComponent from "/Users/adrian/vue/laolife/newlife-web-about/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43cdb5f2"]])

export default __exports__